import React, { createContext, useContext, useState, useEffect } from 'react';
import useSettings from '../hooks/useSettings';

const SidebarContext = createContext(undefined);

export const useSidebar = () => {
	const context = useContext(SidebarContext);
	if (!context) {
		throw new Error('useSidebar must be used within a SidebarProvider');
	}
	return context;
};

export const SidebarProvider = ({ children }) => {
	const { get: getSettings, set: setSettings } = useSettings();
	const getSidebarToggle = getSettings('sidebarToggle');

	const [isExpanded, setIsExpanded] = useState(false); // true = open
	const [isMobileOpen, setIsMobileOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const [isHovered, setIsHovered] = useState(false);
	const [activeItem, setActiveItem] = useState(null);
	const [openSubmenu, setOpenSubmenu] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			const mobile = window.innerWidth < 768;
			setIsMobile(mobile);
			if (!mobile) {
				setIsMobileOpen(false);
			}
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (typeof getSidebarToggle !== 'undefined') {
			setIsExpanded(getSidebarToggle);
		}
	}, [getSidebarToggle]);

	const toggleSidebar = () => {
		setIsExpanded((prev) => !prev);
		setSettings('user', 'sidebarToggle', !isExpanded);
	};

	const toggleMobileSidebar = () => {
		setIsMobileOpen((prev) => !prev);
	};

	const toggleSubmenu = (item) => {
		setOpenSubmenu((prev) => (prev === item ? null : item));
	};

	return (
		<SidebarContext.Provider
			value={{
				isExpanded: isMobile ? false : isExpanded,
				isMobileOpen,
				isMobile,
				isHovered,
				activeItem,
				openSubmenu,
				toggleSidebar,
				toggleMobileSidebar,
				setIsHovered,
				setActiveItem,
				toggleSubmenu,
			}}
		>
			{children}
		</SidebarContext.Provider>
	);
};
